import { render, staticRenderFns } from "./ProductFormModal.vue?vue&type=template&id=5115e6a6&scoped=true&"
import script from "./ProductFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115e6a6",
  null
  
)

export default component.exports